/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Link_CopiedInputs */



/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Common_Link_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_link_copied = /** @type {((inputs?: Common_Link_CopiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Link_CopiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lien copié")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enlace copiado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Link copiado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Link copiato")
	return /** @type {LocalizedString} */ ("Link copied")
});